module.exports = __webpack_public_path__ + "static/compass-and-forest-946a4521fc9c23cb6acee8b4713edc6a.jpeg";